var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c("ItpFormSelect2", {
        attrs: {
          name: "partner",
          "bind-object": "",
          taggable: "",
          dataSource: _vm.b_2248226175642056_dataSource,
          valueField: "id",
          textField: "name",
          clearable: "",
          optionTemplate: _vm.b_2248226175642056_optionTemplate,
          "use-option-template-for-selected-option": "",
          readonly: _vm.editor.isReadonly
        },
        on: {
          optionSelected: function($event) {
            return _vm.evh_2248226175642056_optionSelected($event, {})
          }
        },
        model: {
          value: _vm.editor.partner,
          callback: function($$v) {
            _vm.$set(_vm.editor, "partner", $$v)
          },
          expression: "editor.partner"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }